import './LegalPages.css';

export default function CookiesPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="legal-back">← Back to Home</a>
        
        <h1>Cookie Policy</h1>
        <p className="legal-updated">Last updated: January 2026</p>

        <section>
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website or use an 
            application. They help provide functionality, remember preferences, and enable analytics.
          </p>
        </section>

        <section>
          <h2>How We Use Cookies</h2>
          <p>Nexus AI Recommendations uses cookies for the following purposes:</p>

          <h3>Essential Cookies</h3>
          <p>
            These cookies are necessary for the app to function properly. They include:
          </p>
          <ul>
            <li><strong>Session cookies:</strong> Maintain your authenticated session within Shopify</li>
            <li><strong>Security cookies:</strong> Help protect against unauthorized access</li>
          </ul>

          <h3>Analytics Cookies</h3>
          <p>
            These cookies help us understand how merchants use our app:
          </p>
          <ul>
            <li><strong>Usage analytics:</strong> Track feature usage and page views within the app</li>
            <li><strong>Performance monitoring:</strong> Identify and fix technical issues</li>
          </ul>

          <h3>Recommendation Cookies</h3>
          <p>
            For the recommendation widget on your store:
          </p>
          <ul>
            <li><strong>Session ID:</strong> Anonymous identifier to track browsing behavior within a session</li>
            <li><strong>Preference cookies:</strong> Remember widget display settings</li>
          </ul>
          <p>
            <strong>Important:</strong> Our recommendation cookies do not contain personally 
            identifiable information. We use anonymous session identifiers.
          </p>
        </section>

        <section>
          <h2>Cookie Duration</h2>
          <table className="cookie-table">
            <thead>
              <tr>
                <th>Cookie Type</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Session cookies</td>
                <td>Until browser is closed</td>
              </tr>
              <tr>
                <td>Analytics cookies</td>
                <td>30 days</td>
              </tr>
              <tr>
                <td>Recommendation session</td>
                <td>7 days</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>Third-Party Cookies</h2>
          <p>
            We do not use third-party advertising cookies. The only third-party cookies that may 
            be present are from Shopify's platform, which are governed by Shopify's own cookie policy.
          </p>
        </section>

        <section>
          <h2>Managing Cookies</h2>
          <p>
            You can control cookies through your browser settings. Note that disabling certain 
            cookies may affect the functionality of our app and the recommendation widget.
          </p>
          <p>
            Most browsers allow you to:
          </p>
          <ul>
            <li>View what cookies are stored</li>
            <li>Delete individual or all cookies</li>
            <li>Block cookies from specific sites</li>
            <li>Block all cookies (may affect functionality)</li>
          </ul>
        </section>

        <section>
          <h2>For Your Customers</h2>
          <p>
            The recommendation widget on your store uses minimal, anonymous cookies. We recommend 
            including information about these cookies in your store's cookie policy. Our cookies 
            are designed to be GDPR and ePrivacy Directive compliant.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about our cookie practices:<br />
            <strong>Email:</strong> <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
